import { requireDashboardOrigin } from "@api/features/dashboard-auth/origin/dashboardOriginGuard"
import { requireDashboardAuth } from "@api/features/dashboard-auth/session/requireDashboardAuth"
import { serverRouteConfig } from "@server/server-route-config"
import { dashboardApiErrorMessage } from "@site-server/dashboard-api-errors"
import { createFileRoute } from "@tanstack/react-router"
import * as z from "zod"

const updateDashboardProfileImageInputSchema = z.object({
  profileImageUrl: z.string().url().max(2048).nullable(),
})

export const Route = createFileRoute("/api/dashboard/profile/image")(
  serverRouteConfig({
    server: {
      handlers: {
        POST: async ({ request }) => {
          const originError = requireDashboardOrigin(request)
          if (originError) return originError

          try {
            const input = updateDashboardProfileImageInputSchema.parse(await request.json())
            const auth = await requireDashboardAuth(request, [])
            if ("response" in auth) return auth.response

            const { updateCurrentDashboardProfileImage } = await import(
              "@api/features/dashboard-profile/dashboardProfile"
            )
            return Response.json(
              await updateCurrentDashboardProfileImage({
                profileImageUrl: input.profileImageUrl,
                user: auth.user,
              })
            )
          } catch (error) {
            return Response.json(
              { error: dashboardApiErrorMessage(error, "Could not save profile image.") },
              { status: 400 }
            )
          }
        },
      },
    },
  })
)
